module.exports = __webpack_public_path__ + "img/2.6e233e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brochure/academic/2.png
// module id = 587
// module chunks = 5